import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
import { Button, Modal, RecordsTable, } from "@eudonet/opal";
import { computed, ref, useId } from "vue";
import { useI18n } from "vue-i18n";
import { buildContactAddressColumns } from "./contactAddressTable";
import ContactEditAddressFormModal from "./ContactEditAddressFormModal.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactAddressesExpandModal',
    props: {
        modelValue: { type: Boolean },
        addresses: {},
        contactId: {},
        canEdit: { type: Boolean }
    },
    emits: ["update:modelValue", "updated", "delete", "update:primary"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const titleId = useId();
        const showEditModal = ref(false);
        const editTarget = ref(null);
        const onEdit = (address) => {
            editTarget.value = address;
            showEditModal.value = true;
        };
        const onDeleteFromModal = () => {
            if (editTarget.value)
                emit("delete", editTarget.value);
            showEditModal.value = false;
        };
        const primaryId = computed(() => props.addresses.find((a) => a.isPrimary)?.id ?? "");
        const columns = computed(() => buildContactAddressColumns({
            t,
            primaryId: primaryId.value,
            onSetPrimary: (target) => emit("update:primary", target),
            radioPrefix: "primary-modal",
            canEdit: props.canEdit,
            onEdit: props.canEdit ? onEdit : undefined,
            onDelete: props.canEdit ? (address) => emit("delete", address) : undefined,
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Modal), {
                    "model-value": __props.modelValue,
                    size: "xl",
                    "show-close-button": true,
                    "show-header": true,
                    "aria-labelledby": _unref(titleId),
                    "footer-position": "right",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('update:modelValue', $event)))
                }, {
                    header: _withCtx(() => [
                        _createElementVNode("h2", {
                            id: _unref(titleId),
                            class: "text-xl font-bold text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                        }, _toDisplayString(_ctx.$t("contact.detail.addresses.title")), 9 /* TEXT, PROPS */, _hoisted_1)
                    ]),
                    footer: _withCtx(() => [
                        _createVNode(_unref(Button), {
                            variant: "secondary",
                            label: _ctx.$t('contact.detail.addresses.modal.close'),
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:modelValue', false)))
                        }, null, 8 /* PROPS */, ["label"])
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_unref(RecordsTable), {
                            columns: columns.value,
                            data: __props.addresses,
                            "table-class": 'min-w-130',
                            "empty-text": _ctx.$t('contact.detail.addresses.empty')
                        }, null, 8 /* PROPS */, ["columns", "data", "empty-text"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["model-value", "aria-labelledby"]),
                (editTarget.value)
                    ? (_openBlock(), _createBlock(ContactEditAddressFormModal, {
                        key: 0,
                        modelValue: showEditModal.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((showEditModal).value = $event)),
                        "contact-id": __props.contactId,
                        "initial-address": editTarget.value,
                        onUpdated: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('updated'))),
                        onDelete: onDeleteFromModal
                    }, null, 8 /* PROPS */, ["modelValue", "contact-id", "initial-address"]))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
